/**
 * Mirrors backend hrms-backend/src/utils/navPermissions.js behavior.
 */

function upperRole(role) {
  return (role || "EMPLOYEE").toUpperCase();
}

export function isPrivilegedNavRole(role) {
  const r = upperRole(role);
  return r === "ADMIN" || r === "MANAGER";
}

/** Normalize: null → null; string[] → { path, access: 'write' }[]; objects kept. */
export function normalizeNavPermissions(raw) {
  if (raw === null || raw === undefined) return null;
  if (!Array.isArray(raw)) return null;
  if (raw.length === 0) return [];
  if (typeof raw[0] === "string") {
    return raw.map((path) => ({ path, access: "write" }));
  }
  return raw.map((entry) => ({
    path: String(entry.path || ""),
    access: entry.access === "read" ? "read" : "write",
  }));
}

export function hasNavPath(user, navKey) {
  if (!navKey) return true;
  if (!user) return false;
  const raw = user?.navPermissions;
  if (raw === null || raw === undefined) return true;
  if (!Array.isArray(raw)) return true;

  if (raw.length === 0) return false;
  if (typeof raw[0] === "string") {
    return raw.includes(navKey);
  }
  return raw.some(
    (e) => e && e.path === navKey && (e.access === "read" || e.access === "write")
  );
}

export function hasNavWrite(user, path) {
  if (!path) return true;
  if (!user) return false;
  if (isPrivilegedNavRole(user?.role)) return true;
  const raw = user?.navPermissions;
  if (raw === null || raw === undefined) return true;
  if (!Array.isArray(raw)) return true;

  if (raw.length === 0) return false;
  if (typeof raw[0] === "string") {
    return raw.includes(path);
  }
  const entry = raw.find((e) => e && e.path === path);
  return Boolean(entry && entry.access === "write");
}
